import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import { Transition } from 'react-transition-group';
import { u as useModal } from '../Modal/useModalBehaviors-CGKUe7-Y.js';
import { O as Overlay } from './Overlay-Cvt8VZjb.js';
import { P as Portal } from '../Portal/Portal-CfuGnhf3.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const SecondaryView = props => {
  const closeButtonRef = useRef(null);
  const containerRef = useRef(null);
  const fadeDuration = 150;
  const {
    children,
    closeButtonLabel = 'Done',
    closeButtonProps,
    isOpen = false,
    onClose = noop,
    padding = 'base',
    paddingBlockStart,
    paddingBlockEnd,
    paddingInlineStart,
    paddingInlineEnd,
    secondaryViewElementId,
    toggleEl,
    taktId,
    taktValue,
    ...rest
  } = props;
  const {
    handleKeyUp,
    handleKeyDown,
    handleFocusOnExit,
    handleFocusOnEnter
  } = useModal({
    initialRef: containerRef,
    onClose,
    triggerRef: toggleEl,
    firstRef: closeButtonRef
  });
  const teardown = useCallback(() => {
    handleFocusOnExit();
  }, [handleFocusOnExit]);
  return /*#__PURE__*/React__default.createElement(Transition, {
    timeout: fadeDuration,
    appear: true,
    in: isOpen,
    onExit: teardown,
    onEntered: handleFocusOnEnter,
    nodeRef: containerRef
  }, transitionState => {
    if (transitionState === 'exited') return null;
    return /*#__PURE__*/React__default.createElement(Portal, {
      containerId: secondaryViewElementId
    }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('secondary-view')
    }, /*#__PURE__*/React__default.createElement(Overlay, _extends({}, rest, {
      closeButtonProps: closeButtonProps,
      fadeDuration: fadeDuration,
      transitionState: transitionState,
      handleKeyDown: handleKeyDown,
      handleKeyUp: handleKeyUp,
      containerRef: containerRef,
      onClose: onClose,
      closeButtonRef: closeButtonRef,
      closeButtonLabel: closeButtonLabel,
      padding: padding,
      paddingBlockStart: paddingBlockStart,
      paddingBlockEnd: paddingBlockEnd,
      paddingInlineStart: paddingInlineStart,
      paddingInlineEnd: paddingInlineEnd
    }), children)));
  });
};

export { SecondaryView as S };
//# sourceMappingURL=SecondaryView-D6y2TSS-.js.map
